import { css, styled, typographyClasses } from '@mui/material';

export const StyledVerticalContent = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledPaymentItemContainer = styled('div')`
  display: flex;
  align-items: center;
`;

export const StyledPaymentItemIcon = styled('img')(
  ({ theme }) => css`
    height: ${theme.spacing('1XL')};
    width: ${theme.spacing('1XL')};

    ${theme.breakpoints.up('desktop')} {
      height: ${theme.spacing('2XL')};
      width: ${theme.spacing('2XL')};
    }
  `
);

export const StyledVerticalInternalContent = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    row-gap: ${theme.spacing('SMALL')};
  `
);

export const StyledPaymentStatusLabel = styled('div')(
  ({ theme }) => css`
    .${typographyClasses.root} {
      align-items: center;
      column-gap: ${theme.spacing('SMALL')};
      display: flex;

      &::before {
        width: ${theme.spacing('1XL')};
        height: ${theme.spacing('1XL')};
      }
    }
  `
);

export const StyledPaymentStatusSuccessLabel = styled(StyledPaymentStatusLabel)`
  .${typographyClasses.root}::before {
    content: url(/images/design-assets/status_success.svg);
  }
`;

export const StyledPaymentStatusInfoLabel = styled(StyledPaymentStatusLabel)`
  .${typographyClasses.root}::before {
    content: url(/images/design-assets/status_info.svg);
  }
`;

export const StyledPaymentStatusBlockedLabel = styled(StyledPaymentStatusLabel)`
  .${typographyClasses.root}::before {
    content: url(/images/design-assets/status_blocked.svg);
  }
`;

export const StyledPaymentStatusCancelledLabel = styled(StyledPaymentStatusLabel)`
  .${typographyClasses.root}::before {
    content: url(/images/design-assets/status_cancelled.svg);
  }
`;
